export type InternationalDestinationTab = {
  key: string
  label: string
  /** ISO country codes matched against flash-sale `productMetaData.countryCode` */
  countryCodes: string[]
}

/**
 * Fixed destination tabs for "Vé máy bay Quốc tế" (marketing order).
 * Groups like "Lào, Campuchia" and "Châu Âu" are intentional.
 */
export const INTERNATIONAL_DESTINATION_TABS: InternationalDestinationTab[] = [
  { key: "TH", label: "Thái Lan", countryCodes: ["TH"] },
  { key: "MY", label: "Malaysia", countryCodes: ["MY"] },
  { key: "SG", label: "Singapore", countryCodes: ["SG"] },
  { key: "LA_KH", label: "Lào, Campuchia", countryCodes: ["LA", "KH"] },
  { key: "CN", label: "Trung Quốc", countryCodes: ["CN"] },
  { key: "KR", label: "Hàn Quốc", countryCodes: ["KR"] },
  { key: "JP", label: "Nhật Bản", countryCodes: ["JP"] },
  { key: "TW", label: "Đài Loan", countryCodes: ["TW"] },
  { key: "AU", label: "Úc", countryCodes: ["AU"] },
  { key: "US", label: "Mỹ", countryCodes: ["US"] },
  {
    key: "EU",
    label: "Châu Âu",
    countryCodes: [
      "AT", "BE", "BG", "CH", "CZ", "DE", "DK", "ES", "FI", "FR",
      "GB", "GR", "HU", "IE", "IT", "NL", "NO", "PL", "PT", "RO",
      "RU", "SE",
    ],
  },
]

export const getInternationalDestinationCountryCodes = (tabKey: string): string[] => {
  const tab = INTERNATIONAL_DESTINATION_TABS.find((t) => t.key === tabKey)
  return tab?.countryCodes ?? (tabKey ? [tabKey] : [])
}
